import { theme as baseTheme } from 'roo-ui';
import { merge } from 'lodash';
import { rem } from 'polished';
import * as icons from './icons';

const aditionalValues = {
  zIndices: {
    header: 100,
    phoneMenuDrawer: 501,
    phoneMenuDrawerClose: 502,
  },
  shadows: {
    soft: '0 1px 20px rgba(0, 0, 0, 0.15)',
  },
  uiStructure: {
    phoneMenuDrawerCloseWidth: rem('64px'),
  },
  fontSizes: {
    // TODO: unify hotels & self-service font sizes and remove fontSizes.header.* tokens
    header: {
      xs: rem('15px'),
      sm: rem('16px'),
      base: rem('18px'),
      md: rem('20px'),
      lg: rem('24px'),
      xl: rem('32px'),
      '2xl': rem('34px'),
      '3xl': rem('36px'),
      '4xl': rem('46px'),
    },
  },
};

export const theme = merge(
  aditionalValues,
  baseTheme,

  // lodash.merge does not know how to merge modules
  {
    icons: {
      ...baseTheme.icons,
      ...icons,
    },
  }
);
